export default __webpack_public_path__ + "static/media/man-head-icon-1.71193ade.svg";